import styled from 'styled-components/macro';

export const CloseButtonContainer = styled.div`
  position: absolute;
  right: 15px;
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: center;
  font-size: 24px;
  font-weight: 300;
`;

export const ConfirmationText = styled.p`
  margin: 30px;
  text-align: center;
  font-size: 14px;
`;

export const ConfirmButtonContainer = styled.div`
  margin: 0 38px 12px 0;
  justify-content: flex-end;
  display: flex;
  position: relative;
`;

export const BoldText = styled.span`
  font-weight: 700;
`;
